import { useEffect, useState } from "react";
import ERPAnalyticsHeader from "../components/ERPAnalyticsHeader";
import { api } from "../lib/api";
import { Building2 } from "lucide-react";

export default function Workspaces() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/workspaces").then((r) => setRows(r.data.workspaces || [])).catch(() => {});
  }, []);

  return (
    <div className="erp-home-shell">
      <ERPAnalyticsHeader />

      <main className="erp-content">
        <div className="erp-page-title-row">
          <div>
            <h1>Workspaces</h1>
            <p>Multi-tenant client workspaces managed inside Camaroo Analytics.</p>
          </div>
        </div>

        <div className="erp-card">
          <table className="tbl" data-testid="workspaces-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th>Type</th>
                <th>Created</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((w) => (
                <tr key={w.id || w.slug || w.name}>
                  <td>
                    <span className="inline-flex items-center gap-2">
                      <Building2 size={14} strokeWidth={1.8} />
                      {w.name || "—"}
                    </span>
                  </td>
                  <td className="font-mono text-[12px]">{w.slug || "—"}</td>
                  <td><span className="pill">{w.type || "Standard"}</span></td>
                  <td>{w.created_at ? new Date(w.created_at).toLocaleString() : "—"}</td>
                </tr>
              ))}

              {rows.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center py-6" style={{ color: "var(--c-text-muted)" }}>
                    No workspaces found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
